export default __webpack_public_path__ + "c979fa2651150f711163debf81723b14.png";